import axios from '@/utils/axios'

let cachedStandard = null
let cachedDimensional = null

export async function getStandardUnits() {
    if (cachedStandard) return cachedStandard
    const res = await axios.get('/units?type=standard')
    cachedStandard = res.data.data
    return cachedStandard
}

export async function getDimensionalUnits() {
    if (cachedDimensional) return cachedDimensional
    const res = await axios.get('/units?type=dimensional')
    cachedDimensional = res.data.data
    return cachedDimensional
}

// Call this if units are updated in settings
export function clearUnitsCache() {
    cachedStandard = null
    cachedDimensional = null
}